module.exports = __webpack_public_path__ + "static/media/home3.7f5c3db6.png";